module.exports = __webpack_public_path__ + "01f43047/img/link-icon.fa09ed66.svg";